/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Social_Export_TitleInputs */

const cs_social_export_title = /** @type {(inputs: Social_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export na sociální sítě`)
};

const en_social_export_title = /** @type {(inputs: Social_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Social export`)
};

/**
* | output |
* | --- |
* | "Social export" |
*
* @param {Social_Export_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const social_export_title = /** @type {((inputs?: Social_Export_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Social_Export_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_social_export_title(inputs)
	return cs_social_export_title(inputs)
});